import { useOrderPanelStore } from '../../stores/order-panel-store'
import { bootstrapHasWederverkoper } from '../../lib/pricing/wederverkoper'

/**
 * Wederverkoper-checkbox (alleen page-variant) — zet alle kleden op het
 * wederverkoper-tarief + minimum €150 + bundelkorting uit. Pariteit met de
 * booking-flow intern-toggle (ContextStep). Verbergt zichzelf als de SKU niet
 * in de bootstrap zit (dan is er geen tarief om toe te passen).
 */
export function WederverkoperToggle() {
  const bootstrapRaw = useOrderPanelStore((s) => s.bootstrapRaw)
  const isWederverkoper = useOrderPanelStore((s) => s.isWederverkoper)
  const setIsWederverkoper = useOrderPanelStore((s) => s.setIsWederverkoper)

  if (!bootstrapHasWederverkoper(bootstrapRaw)) return null

  return (
    <div className="space-y-1.5">
      <label className="flex items-center gap-2 cursor-pointer text-sm">
        <input
          type="checkbox"
          checked={isWederverkoper}
          onChange={(e) => setIsWederverkoper(e.target.checked)}
          className="rounded border-slate-300"
        />
        <span className="font-medium">Wederverkoper — wederverkoper-tarief toepassen</span>
      </label>
      {isWederverkoper && (
        <p className="text-xs text-slate-500">
          Alle kleden op wederverkoper-tarief · minimum €150 excl. BTW · geen bundelkorting.
        </p>
      )}
    </div>
  )
}
